var _path, _path2, _circle, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHowToCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5889 10.9131C29.0655 9.5915 30.9345 9.5915 31.4111 10.9131L35.1974 21.4131C35.4059 21.9913 35.9462 22.3839 36.5606 22.4035L47.7167 22.7598C49.1209 22.8047 49.6984 24.5822 48.5888 25.4438L39.7727 32.2895C39.2872 32.6665 39.0809 33.3016 39.252 33.892L42.3606 44.6123C42.7518 45.9615 41.2398 47.0601 40.0775 46.2711L30.8425 40.0019C30.3339 39.6567 29.6661 39.6567 29.1575 40.0019L19.9225 46.2711C18.7602 47.0601 17.2482 45.9615 17.6394 44.6123L20.748 33.892C20.9191 33.3016 20.7128 32.6665 20.2273 32.2895L11.4112 25.4438C10.3016 24.5822 10.8791 22.8047 12.2833 22.7598L23.4394 22.4035C24.0538 22.3839 24.5941 21.9913 24.8026 21.4131L28.5889 10.9131Z",
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6705 35.8838H33.2242C33.689 35.8838 34.0377 35.585 34.0377 35.1201C34.0377 34.647 33.689 34.3481 33.2242 34.3481H27.5797V34.3066C28.4512 33.9165 28.9825 32.8955 28.9825 31.5923C28.9825 31.2104 28.941 30.8701 28.8829 30.5547H32.0206C32.3941 30.5547 32.668 30.314 32.668 29.957C32.668 29.6001 32.3941 29.3594 32.0206 29.3594H28.5924C28.4678 28.8945 28.3765 28.4048 28.3765 27.7988C28.3765 26.4458 29.3643 25.541 31.0079 25.541C31.9625 25.541 32.419 25.7485 32.8673 25.7485C33.2989 25.7485 33.5479 25.4995 33.5479 25.0928C33.5479 24.7441 33.357 24.4951 32.9586 24.3125C32.336 24.0469 31.6221 23.9888 30.7921 23.9888C28.169 23.9888 26.5172 25.4663 26.5172 27.7822C26.5172 28.3052 26.6168 28.8447 26.733 29.3594H25.4464C25.0728 29.3594 24.7989 29.6001 24.7989 29.957C24.7989 30.314 25.0728 30.5547 25.4464 30.5547H27.0318C27.1231 30.9531 27.1812 31.3267 27.1812 31.667C27.1812 33.0698 26.376 33.8999 25.5709 34.207C25.1143 34.3979 24.8819 34.6636 24.8819 35.1035C24.8819 35.5684 25.2056 35.8838 25.6705 35.8838Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 29,
    r: 26.375,
    stroke: "#2D2926",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 30C4 15.0883 15.0883 3 30 3C44.9117 3 56 15.0883 56 30",
    stroke: "#2D2926",
    strokeWidth: 1.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56 30C56 48.3607 44.3594 58 30 58C15.6406 58 4 47.4426 4 30",
    stroke: "#2D2926",
    strokeWidth: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHowToCoin);
export default __webpack_public_path__ + "static/media/iconHowToCoin.70a4ab6438bdf0d00c0475833255b726.svg";
export { ForwardRef as ReactComponent };